import CpfToast from "../../utils/checkout/CpfToast";

export default class SessionRecap {

    constructor() {
        this.bindEvents();
        this.toast = new CpfToast();
        this.dataLayer = {};

        window.application.setOnDataChangeListener(this);
    }


    bindEvents() {
        $('#add_to_cart').on('click', () => this.setGtmDataLayer() );

        $('#toggle-description').on('click', (e) => {
            e.preventDefault();
            $('#formulaDescription').collapse('toggle');
            $('#toggle-description').find('.toggle-text').text($('.toggle-text').text() === 'Voir plus' ? 'Voir moins' : 'Voir plus');
            $('#toggle-description').find('.toggle-icon').toggleClass('chevron-down-icon chevron-up-icon');
        });
    }

    onDataChanged(data) {
        if(data.dataLayer){ this.dataLayer = data.dataLayer; }
    }

    onDestroy() {
    }

    setGtmDataLayer() {
        window.dataLayer.push(this.dataLayer);
    }
}